import { useState } from "react";
import { createModel } from "hox";

export const useHomerModal = createModel(function () {

    const [isRender, setIsRender] = useState<boolean>(false);

    return {
        /***field***/
        isRender, setIsRender,
    }
});